import Typography from '@/common/components/base/typography/Typography';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

function CircularTimer({ time, fraction }: { time: number; fraction: number }) {
  const radius = 28;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - fraction * circumference;

  return (
    <Box
      className={css({
        position: 'absolute',
        right: 0,
        bottom: 10,
        width: '120px',
        height: '120px',
      })}
    >
      <svg
        width="120"
        height="120"
        className={css({ position: 'absolute', top: 0, left: 0 })}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          stroke="#ddd"
          strokeWidth="8"
          fill="#ffffff"
          r={radius}
          cx="60"
          cy="60"
          style={{
            strokeDasharray: circumference,
            strokeDashoffset: 0,
          }}
        />

        <circle
          stroke={token('colors.purple-primary')}
          strokeWidth="8"
          fill="transparent"
          r={radius}
          cx="60"
          cy="60"
          style={{
            strokeDasharray: circumference,
            strokeDashoffset: offset,
            transition: 'stroke-dashoffset 0.35s',
          }}
        />
        <path
          transform="translate(27.5,26.5) scale(1.55)"
          d="M35.5058 36.2297C39.0268 32.6725 41.133 27.9661 41.4342 22.9824H43.3462V24.9559C43.343 25.3095 43.481 25.6499 43.7299 25.9022C43.9788 26.1546 44.3182 26.2983 44.6736 26.3017C45.0287 26.298 45.3679 26.1542 45.6166 25.9019C45.8653 25.6496 46.0032 25.3093 45.9999 24.9559V18.3213C46.0032 17.9677 45.8652 17.6273 45.6162 17.375C45.3673 17.1226 45.0279 16.9789 44.6726 16.9755C44.3174 16.9792 43.9782 17.123 43.7296 17.3753C43.4809 17.6277 43.343 17.9679 43.3462 18.3213V20.2948H41.4342C41.227 16.9041 40.1843 13.6162 38.398 10.7213L39.66 9.43763C40.2709 8.81416 40.6129 7.97785 40.6129 7.10707C40.6129 6.2363 40.2709 5.39999 39.66 4.77652L37.7399 2.83198C37.4411 2.52806 37.0843 2.28659 36.6905 2.12173C36.2966 1.95688 35.8737 1.87196 35.4464 1.87196C35.0191 1.87196 34.5962 1.95688 34.2023 2.12173C33.8085 2.28659 33.4517 2.52806 33.153 2.83198L31.8809 4.11966C27.98 1.65635 23.3465 0.602498 18.7575 1.13484C14.1684 1.66719 9.90278 3.75335 6.67604 7.04349C2.84699 10.9458 0.7035 16.1833 0.7035 21.6371C0.7035 27.0909 2.84699 32.3284 6.67604 36.2307C8.55231 38.1436 10.7942 39.6638 13.2698 40.7017C15.7453 41.7396 18.4046 42.2742 21.0909 42.2742C23.7773 42.2742 26.4365 41.7396 28.9121 40.7017C31.3876 39.6638 33.6295 38.1426 35.5058 36.2297ZM35.8651 4.73747L37.7862 6.68202C37.8979 6.79577 37.9605 6.94851 37.9605 7.10758C37.9605 7.26664 37.8979 7.41939 37.7862 7.53313L36.8221 8.50841C36.4088 8.00241 35.97 7.51411 35.5058 7.04349C35.0415 6.57287 34.5605 6.12996 34.0627 5.71475L35.0278 4.73747C35.0823 4.682 35.1474 4.63794 35.2193 4.60785C35.2912 4.57776 35.3684 4.56226 35.4464 4.56226C35.5244 4.56226 35.6016 4.57776 35.6735 4.60785C35.7454 4.63794 35.8105 4.682 35.8651 4.73747ZM3.36013 21.6366C3.3258 16.9192 5.17312 12.3808 8.49698 9.01668C11.8208 5.65257 16.3499 3.73737 21.0909 3.6911C25.822 3.76973 30.3325 5.69494 33.6503 9.05172C36.9681 12.4085 38.8274 16.928 38.8274 21.6361C38.8274 26.3442 36.9681 30.8637 33.6503 34.2205C30.3325 37.5773 25.822 39.5025 21.0909 39.5811C16.3496 39.5356 11.8201 37.6209 8.49575 34.2569C5.17142 30.8929 3.32379 26.3543 3.35812 21.6366H3.36013Z"
          fill="white"
          stroke="#707070"
          strokeWidth="0.9"
        />
      </svg>

      <Box
        className={css({
          position: 'absolute',
          top: '50%',
          left: '48%',
          display: 'inline-block',
          transform: 'translate(-50%, -50%) rotate(90deg) ',
          width: '30px',
          height: '40px',
        })}
      >
        <Typography textAlign="center" fontSize={20} color="black-1">
          {time}
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularTimer;
